import axios from 'axios';
import { setHeadquarterLocationId } from '../../helpers/auth';

// Sanctum sagt, wir brauchen das?
axios.defaults.withCredentials = true;

const toLoginError = (error) => {
    if (error.response && error.response.status === 429) {
        throw new Error(
            'Zu viele Versuche. Bitte warten Sie eine Minute und versuchen Sie es erneut.'
        );
    }
    if (error.response && error.response.data) {
        throw error.response.data;
    }
    throw error;
};

const getCSRFCookie = () =>
    axios({
        method: 'get',
        url: '/v3/sanctum/csrf-cookie',
        baseURL: process.env.REACT_APP_API_ROOT, // FIXME: should be REACT_APP_API_AUTH
    });

const getAuthenticated = (data) =>
    axios({
        method: 'get',
        url: '/api/v3/users/me',
        baseURL: process.env.REACT_APP_API_ROOT,
    }).then((response) => {
        setHeadquarterLocationId(response.data.data.headquarterLocationId);
        return { ...data, userV3: response.data.data };
    });

const authenticate = (data) =>
    data.credentials
        ? getCSRFCookie().then(() =>
              axios({
                  method: 'post',
                  url: '/v3/auth/login',
                  baseURL: process.env.REACT_APP_API_ROOT,
                  data: data.credentials,
              })
                  // the login returns the APIv2 token too (issued after the OTP check)
                  .then((response) =>
                      getAuthenticated({ ...data, apiKey: response.data && response.data.apiKey })
                  )
                  .catch(toLoginError)
          )
        : getAuthenticated(data);

const requestOTP = (data) =>
    axios({
        method: 'post',
        url: '/api/v3/requestotp',
        baseURL: process.env.REACT_APP_API_ROOT,
        data: data.credentials,
    })
        .then((response) => {
            return response.data;
        })
        .catch(toLoginError);

const logout = () =>
    getCSRFCookie().then(() =>
        axios({
            method: 'post',
            url: '/v3/auth/logout',
            baseURL: process.env.REACT_APP_API_ROOT,
        })
    );

export const attachAuthentication = (api) => {
    api.onRequestOTP(requestOTP);
    api.onAuthenticate(authenticate);
    api.onLogout(logout);
};
